import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map, of } from "rxjs";
import { AssignmentService } from "src/app/assignment/services/assignment.service";
import { IBaseSearchRequest } from "src/app/core/models/base";

/**
 * Checks that the internal number is not used by another assignment.
 * @param getCurrentAssignmentId returns the id of the assignment being edited (null when creating),
 *                               so the assignment may keep its own number.
 */
export function AssignmentInternalNumberValidator(
    assignmentService: AssignmentService,
    getCurrentAssignmentId: () => string | null = () => null
): AsyncValidatorFn {
    return  (control: AbstractControl) => {
        // check if form has yet been changed
        // prevent unnecessary api call and initial error message
        if(control.pristine || !control.value?.toString().trim()){
            return of(null);
        }

        const request : IBaseSearchRequest= {
            pageNumber:0,
            pageSize: 999999,
            advancedFilter:{
                logic: "and",
                filters: [
                    {
                        field: 'internalNumber',
                        operator: 'eq',
                        value: control.value
                    }
                ]
            }
        }

        return assignmentService.searchAssignments(request)
            .pipe(
                map(response => {
                    const currentId = getCurrentAssignmentId();
                    const others = response.data.filter(a => a.id !== currentId);

                    return others.length != 0 ? {internalNumberExists: true} : null;
                })
            )
    }
}
